import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

const greyExtraLight700 = ui.neutral[25];

export interface InsightsLayoutCssProps {
  displaySidebar: boolean | undefined;
}

export const insightsLayoutCss = {
  position: "relative" as const,
  display: "grid",
  gridTemplateAreas: `
    "data" 
    "footer"
  `,
  "&:has(aside)": {
    gridTemplateAreas: `
      "sidebar data" 
      "sidebar footer" 
    `,
    gridTemplateColumns: "231px calc(100vw - 231px)",
  },
  gridTemplateColumns: "1fr",
  footer: {
    gridArea: "footer",
    backgroundColor: ui.white[700],
  },
};

export const insightsDataLayoutCss = ({
  displaySidebar,
}: InsightsLayoutCssProps) => ({
  gridArea: "data",
  width: displaySidebar ? "100%" : "100vw",
  padding: displaySidebar ? "24px 40px 80px 40px" : "24px 16px 80px 16px",
});

export const insightsSideBarCss = {
  gridArea: "sidebar",
  width: "100%",
  backgroundColor: greyExtraLight700,
  padding: "32px 24px 0 24px",
};
